import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Image, P, UL } from '../../../../AbstractElements';
import { firebase_app } from '../../../../Config/Config';
import { LogOut, User } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import userimg from '../../../../assets/images/user/user.png';
import i18n from '../../../../i18n';
import { findUserForAuthUser } from '../../Users/userFirebase';

const LogoutClass = () => {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const [authUser, setAuthUser] = useState(() => firebase_app.auth().currentUser || null);
    const [profile, setProfile] = useState(null);
    const [profileStatus, setProfileStatus] = useState('loading');
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        let active = true;

        const resolveProfile = async (user) => {
            if (!active) {
                return;
            }

            setAuthUser(user || null);
            setProfile(null);

            if (!user) {
                setProfileStatus('signed-out');
                return;
            }

            setProfileStatus('loading');

            try {
                const matchedProfile = await findUserForAuthUser(user);

                if (active) {
                    setProfile(matchedProfile);
                    setProfileStatus('ready');
                }
            } catch (error) {
                console.error('Unable to resolve user profile menu data', error);

                if (active) {
                    setProfileStatus('error');
                }
            }
        };

        const unsubscribe = firebase_app.auth().onAuthStateChanged(resolveProfile);

        return () => {
            active = false;
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
    }, []);

    useEffect(() => {
        const closeOnOutsideClick = event => {
            if (!isOpen || !dropdownRef.current || dropdownRef.current.contains(event.target)) {
                return;
            }

            setIsOpen(false);
        };

        document.addEventListener('mousedown', closeOnOutsideClick);

        return () => {
            document.removeEventListener('mousedown', closeOnOutsideClick);
        };
    }, [isOpen]);

    const publicUrl = process.env.PUBLIC_URL || '';
    const profilePath = String(profile?.employeeid || profile?.uid || '');
    const profileLink = profilePath
        ? `${publicUrl}/dashboard/users/${profilePath}`
        : `${publicUrl}/dashboard/app/users/userProfile`;
    const profileName = useMemo(() => {
        const fullName = `${profile?.firstname || ''} ${profile?.lastname || ''}`.trim();

        return fullName ||
            authUser?.displayName ||
            localStorage.getItem('Name') ||
            authUser?.email ||
            'Utilisateur MaxPark';
    }, [authUser, profile]);
    const profileSubtitle = profile?.usertype
        ? `${i18n.t('Dashboard_UserProfile_Label')} - ${profile.usertype}`
        : i18n.t('Dashboard_UserProfile_Label');
    const profilePhoto = profile?.photo || authUser?.photoURL || userimg;
    const profileStatusLabel = profileStatus === 'loading'
        ? i18n.t('Dashboard_Users_Loading')
        : profileStatus === 'error'
            ? i18n.t('Dashboard_Users_LoadError')
            : '';

    const closeDropdown = () => setIsOpen(false);

    const handleKeyDown = event => {
        if (event.key === 'Escape') {
            setIsOpen(false);
        }
    };

    const Logout = async (event) => {
        event.preventDefault();
        closeDropdown();
        localStorage.removeItem('profileURL');
        localStorage.removeItem('token');
        localStorage.removeItem('Name');
        localStorage.setItem('authenticated', false);

        try {
            await firebase_app.auth().signOut();
        } catch (error) {
            console.error('Unable to sign out user', error);
        } finally {
            navigate(`${publicUrl}/auth`, { replace: true });
        }
    };

    return (
        <Fragment>
            <li className="onhover-dropdown p-0 noti-primary maxpark-user-menu" ref={dropdownRef} onKeyDown={handleKeyDown}>
                <button
                    type="button"
                    className="notification-box maxpark-notification-toggle"
                    aria-label={i18n.t('Dashboard_UserProfile_Label')}
                    aria-expanded={isOpen}
                    aria-controls="maxpark-user-profile-menu"
                    onClick={() => setIsOpen(open => !open)}
                >
                    <User />
                </button>

                <UL attrUL={{ id: 'maxpark-user-profile-menu', className: `notification-dropdown onhover-show-div ${isOpen ? 'active' : ''}` }} >
                    <li>
                        <Link to={profileLink} onClick={closeDropdown}>
                            <div className="media">
                                <Image attrImage={{ className: 'img-fluid rounded-circle me-2 img-50', src: profilePhoto, alt: profileName }} />
                                <div className="media-body">
                                    <P>{profileName}</P>
                                    <span>{profileSubtitle}</span>
                                    {profileStatusLabel && <span className="d-block">{profileStatusLabel}</span>}
                                </div>
                            </div>
                        </Link>
                    </li>
                    <li className="text-center">
                        <Link to={`${publicUrl}/auth`} onClick={Logout}>
                            <span className="logout-icon">
                                <LogOut />
                            </span>
                            <div className="media-body">
                                <P>{i18n.t('Dashboard_UserProfile_Logout')}</P>
                            </div>
                        </Link>
                    </li>
                </UL>
            </li>
        </Fragment>
    );
};

export default LogoutClass;
